import config from "config";
import { ContentLayoutType1 } from "pages/Product/ContentLayouts/ContentLayoutType1";
import {
  AssetArea,
  DescriptionArea,
  SectionDescription,
  SectionSubTitle,
  SectionTitle,
  TitleArea,
  Video,
} from "pages/Product/ContentLayouts/styled";
import { FeatureSectionWrapper } from "pages/Product/FeaturesSection/styled";
import React from "react";

export function Feedback() {
  return (
    <FeatureSectionWrapper id="feedback">
      <ContentLayoutType1>
        <TitleArea>
          <SectionSubTitle>How can I manage</SectionSubTitle>
          <SectionTitle>Feedback?</SectionTitle>
        </TitleArea>
        <DescriptionArea>
          <SectionDescription>
            You can deliver a clear description with a screen recording. It is
            also easy to leave feedback on various types of deliverables.
          </SectionDescription>
        </DescriptionArea>
        <AssetArea>
          <Video
            src={`${config.RESOURCE_ORIGIN}/videos/landing/product/feature-feedback.mp4`}
            autoPlay
            muted
            loop
            playsInline
          />
        </AssetArea>
      </ContentLayoutType1>
    </FeatureSectionWrapper>
  );
}
